import { Download } from "@mui/icons-material";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import {
  Box,
  CircularProgress,
  Grid2,
  IconButton,
  MenuItem,
  TableCell,
  Typography,
  useTheme,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useMeasure from "react-use-measure";
import { DownloadResume } from "../../../api/Api";
import AnomalyStarIco from "../../../assets/icons/AnomalyStarIco";
import AnomalyTickIco from "../../../assets/icons/AnomalyTickIco";
import CandidateSupportIco from "../../../assets/icons/CandidateSupportIco";
import DeleteIco from "../../../assets/icons/DeleteIco";
import EyeIco from "../../../assets/icons/EyeIco";
import ReportBugIco from "../../../assets/icons/ReportBugIco";
import RescoreIco from "../../../assets/icons/RescoreIco";
import SupportIco from "../../../assets/icons/SupportIco";
import CommonButton from "../../../component/Button";
import CommonLinearProgress from "../../../component/Linearprogress";
import SnackBar from "../../../component/SnackBar";
import {
  CandidateAttachementCreateCall,
  CandidateAttachementDelete,
  CandidateAttachementDownload,
  CandidateAttachementTableGetCall,
  CandidateEditProfile,
  CandidateRescore,
  CandidateStatusChange,
  CandidateViewCall,
  GetCalendlyEventTypes,
  SendCalendlyInvite,
} from "../../../redux/action/Candidate";
import {
  CandidateChatBot,
  CandidateChatBotGetCall,
  SupportCall,
  SupportGetCall,
} from "../../../redux/action/ChatBot";
import { SendInterest } from "../../../redux/action/CoverSheet";
import { FeedBackButton } from "../../../redux/action/Feedback";
import { JobJobRescore } from "../../../redux/action/Job";
import { MinimizeIcon } from "../../../redux/action/Login";
import {
  ResumeIntelligenceDeleteNote,
  ResumeIntelligenceFix,
  ResumeIntelligenceGETNote,
  ResumeIntelligencePostNote,
  ResumeIntelligencePutNote,
} from "../../../redux/action/ResumeIntelligence";
import { GETDOWNLOAD } from "../../../redux/axios/Axios";
import { GetFileIcon } from "../../../utils/constants";
import ChatBotLabelText from "../../chat-bot/ChatBotLabelText";
import SideBarChatBot from "../../chat-bot/SIdeBarChatBot";
import { CustomDiv } from "../../chat-bot/style";
import SkillDeleteDialog from "../../common-components/DeleteDialog";
import NewDeleteNote from "../../common-components/NewDeleteNote";
import {
  CommonGrid2,
  DotColor,
  StyledFlexRowView,
  StyledTableBodyTableCell,
} from "../../common-components/StyledComponents";
import AttachmentDialog from "../../jobs/jobs-candidate/components/AttachementDialog";
import InteractionDialog from "../../jobs/jobs-candidate/components/Dialogbox";
import DialogCandidateHub from "../../jobs/jobs-candidate/components/DialogCandidateHub";
import EditCandidateProfile from "../../jobs/jobs-candidate/components/EditCandidateDialog";
import ScheduleInterview from "../../jobs/jobs-candidate/components/ScheduleInterview";
import { CommonTippy, CustomizeMenu } from "../../jobs/style";
import {
  FileContainer,
  StyledLinearContainer,
} from "../../matches/quick-match/components/StyledComponent";
import ResumeCreateNote from "../../resume-intelligence/create-candidate-resume/components/CreateNote";
import ReviewCandidateProfile from "../../resume-intelligence/create-candidate-resume/components/ReviewCandidateProfile";

const CandidateView = ({ condition_based }) => {
  const [fixLoading, setFixLoading] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const JobRescore = useSelector((state) => state.jobs.jobJobRescore);
  const query = new URLSearchParams(useLocation().search);
  const navigate = useNavigate();
  const viewId = query.get("view-id");
  const dispatch = useDispatch();
  const [downloadMenuLoader, setDownloadMenuLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [resumeData, setResumeData] = useState({});
  const [openNote, setOpenNote] = useState({
    loading: false,
    open: false,
    note: "",
    id: "",
    deleteNote: false,
    created_at: "",
  });
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const [ref, bounds] = useMeasure();
  const [notesTableList, setNotesTableList] = useState([]);
  const [notesTableListLoading, setNotesTableListLoading] = useState(false);
  const noteHeaderData = [
    { name: "Title", direction: "asc", sort: false, width: "50%" },
    { name: "Created By", direction: "asc", sort: false, width: "20%" },
    { name: "Date", direction: "asc", sort: false, width: "15%" },
    { width: "15%" },
  ];
  const interactionHeaderdata = [
    { name: "ID", direction: "asc", sort: false },
    { name: "Made By", direction: "asc", sort: false },
    { name: "Type", direction: "asc", sort: false },
    { name: "Action", direction: "asc", sort: false },
    { name: "Status", direction: "asc", sort: false },
    { name: "Created At", direction: "asc", sort: false },
    { width: "5%" },
  ];
  const [editDialog, setEditDialog] = useState({
    open: false,
    disabled: false,
    cancelLoading: false,
    saveLoading: false,
  });
  const [calendlyEvent, setCalendlyEvent] = useState({
    data: [],
    loading: false,
    open: false,
  });
  const [interAction, setInterAction] = useState({
    data: {},
    open: false,
  });
  const [chatBotData, setChatBotData] = useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    bubbleCondition: false,
    selectedValue: "Candidate",
    expandDrawer: false,
  });
  const [copied, setCopied] = useState(false);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [isBottomVisible, setIsBottomVisible] = useState(true);
  const buttonSupport = [
    {
      name: "Candidate",
      icon: <CandidateSupportIco />,
    },
    {
      name: "Support",
      icon: <SupportIco />,
    },
    {
      name: "Report Bug",
      icon: <ReportBugIco />,
    },
  ];
  const [attachmentList, setAttachmentList] = useState({
    data: [],
    loading: false,
  });
  const [attachementHeaderData, setAttachementHeaderData] = useState([
    { name: "Name", width: "23%" },
    { name: "Type", width: "20%" },
    { name: "Status" },
    { name: "Created by" },
    { name: "Created Date" },
    {},
  ]);
  const statusOptions = [
    { name: "Active", color: "#17B26A", id: "Active" },
    { name: "Unavailable", color: "#9E77ED", id: "Unavailable" },
    { name: "Inactive", color: "#667085", id: "Inactive" },
    { name: "Do Not Hire", color: "#F04438", id: "Do Not Hire" },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const attachementOpen = Boolean(anchorEl);
  const [attachmentDialog, setAttachmentDialog] = useState({
    loading: false,
    disabled: false,
    open: false,
  });
  const [attachementMenuLoader, setAttachementMenuLoader] = useState({
    download: false,
    view: false,
  });
  const [attachementRowData, setAttachementRowData] = useState({});
  const [deleteButton, setDeleteButton] = useState({
    loading: false,
    open: false,
    content: "",
    id: "",
  });
  const [statusDialog, setStatusDialog] = useState({
    open: false,
    disabled: false,
    noLoading: false,
    yesLoading: false,
    value: "",
  });
  const [reScore, setReScore] = useState({
    noLoading: false,
    disabled: false,
    yesLoading: false,
    open: false,
  });

  const handleCandidateViewCall = async () => {
    setIsLoading(true);
    try {
      const data = await dispatch(CandidateViewCall(viewId));
      await fetchAttachmentTableList(data?.id);
      setResumeData(data);
      setIsLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const apiCall = async () => {
      await handleFetchNote();
      await handleCandidateViewCall();
      await fetchCalendlyEventTypes();
    };
    apiCall();
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleScoreFix = async () => {
    setFixLoading(true);
    try {
      const data = await ResumeIntelligenceFix(viewId);
      setFixLoading(false);
      setIsLoading(true);
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      const fixData = await dispatch(CandidateViewCall(viewId));
      setResumeData(fixData);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      setFixLoading(false);
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDownloadResume = () => {
    if (resumeData?.id) {
      setDownloadMenuLoader(true);
      GETDOWNLOAD(DownloadResume(resumeData.id), {
        params: { type: "resume" },
        responseType: "blob",
      })
        .then((response) => {
          const contentType = response.headers["content-type"];
          const fileName = `${resumeData?.resume_file_name}`;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: contentType })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          setDownloadMenuLoader(false);
        })
        .catch((error) => {
          if (error.response && error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              const responseText = reader.result;
              try {
                const json = JSON.parse(responseText);
                const errorMessage =
                  json.error || "An unexpected error occurred.";
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message: errorMessage,
                });
              } catch (e) {
                setSnackbarState({
                  open: true,
                  severity: "error",
                  message:
                    "An unexpected error occurred while parsing the error message.",
                });
              }
            };
            reader.readAsText(error.response.data);
          } else {
            setSnackbarState({
              open: true,
              severity: "error",
              message: "An unexpected error occurred.",
            });
          }
          setDownloadMenuLoader(false);
        });
    } else {
      setSnackbarState({
        open: true,
        severity: "error",
        message: "Resume was not parsed successfully. Unable to download.",
      });
      setDownloadMenuLoader(false);
    }
  };

  const handleFetchNote = async () => {
    try {
      setNotesTableListLoading(true);
      const data = await ResumeIntelligenceGETNote(viewId);
      setNotesTableList(data.data);
      setNotesTableListLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setNotesTableListLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setOpenNote((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = values.id
        ? await ResumeIntelligencePutNote(values.id, values)
        : await ResumeIntelligencePostNote(viewId, [values]);
      await handleFetchNote();
      setSnackbarState({
        open: true,
        message: data?.message || data?.data?.message,
        severity: "success",
      });
      handleCloseNoteDialog();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setOpenNote((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleUpdateNoteClick = (row) => {
    setOpenNote((prev) => ({
      ...prev,
      open: true,
      note: row.note,
      id: row.id,
      created_at: "row.created_at",
    }));
  };

  const handleCloseNoteDialog = () => {
    setOpenNote({
      loading: false,
      open: false,
      note: "",
      id: "",
      deleteNote: false,
    });
  };

  const handleClickAddNote = () => {
    setOpenNote((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleDeleteNoteClick = (row) => {
    setOpenNote((prev) => ({
      ...prev,
      deleteNote: true,
      id: row?.id,
      note: row?.note,
      created_at: row?.created_at,
    }));
  };

  const handleDeleteNoteById = async () => {
    setOpenNote((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const data = await ResumeIntelligenceDeleteNote(openNote.id);
      await handleFetchNote();
      handleCloseNoteDialog();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setOpenNote((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleChatBotCandidateCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
    }));
    try {
      const data = await CandidateChatBotGetCall(viewId);
      const messages = [];
      data?.data.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;
    let payload;
    if (chatBotData.selectedValue === "Candidate") {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "resume_data",
          resume_data_id: viewId,
        },
      };
    } else {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "user_manuals",
          user_id: localStorageData?.user_id,
        },
      };
    }

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      let data;
      if (chatBotData.selectedValue === "Candidate") {
        data = await dispatch(CandidateChatBot(payload));
      } else {
        data = await SupportCall(payload);
      }
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],
        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],
        loader: false,
        value: "",
      }));
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
    }));
    try {
      const data = await SupportGetCall(localStorageData?.user_id);
      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Report Bug") {
      dispatch(FeedBackButton(true));
    } else if (name === "Support") {
      handleSupportCall();
    } else if (name === "Candidate") {
      handleChatBotCandidateCall();
    }
  };

  const handleCopyMouseLeave = () => {
    setTimeout(() => setCopied(false), 200);
  };

  const handleCopyClick = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch (error) {}
  };

  const handleAttachment = () => {
    setAttachmentDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleAttachmentClose = () => {
    setAttachmentDialog({
      loading: false,
      disabled: false,
      open: false,
    });
  };

  const handleAttachmentSubmit = async (values, { setFieldValue }) => {
    try {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: false,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: true,
        disabled: true,
      }));

      const formData = new FormData();

      values.file.forEach((fileObj) => {
        formData.append("file", fileObj.file);
      });
      formData.append("name", values.name);
      const data = await CandidateAttachementCreateCall(
        resumeData?.id,
        formData
      );
      await fetchAttachmentTableList(resumeData?.id);
      handleAttachmentClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      const updatedFiles = values.file.map((file) => ({
        ...file,
        delete: true,
      }));
      setFieldValue("file", updatedFiles);
      setAttachmentDialog((prev) => ({
        ...prev,
        loading: false,
        disabled: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleIconClick = (event, rowData) => {
    setAttachementRowData(rowData);
    setAnchorEl(event.currentTarget);
  };

  const handleAttachmentTableBodyData = (row, index) => (
    <>
      <TableCell>
        <CommonGrid2
          display={"flex"}
          gap={"5px"}
          alignItems={"ceter"}
          flexWrap={"wrap"}
        >
          {row.name || "-"}
          <CommonGrid2 display={"flex"} gap={"5px"} flexWrap={"wrap"}>
            {row.is_scored && (
              <CommonGrid2
                background={"#D1EFFF"}
                width="max-content"
                padding="2px 8px 2px 5px"
                color={"#344054"}
                fontSize="12px"
                fontWeight={700}
                borderRadius="50px"
                display={"flex"}
                alignItems="center"
                gap={"4px"}
              >
                <AnomalyStarIco size={"13px"} />
                Scored
              </CommonGrid2>
            )}
            {row.is_new && (
              <CommonGrid2
                background={"#DBFAE6"}
                width="max-content"
                padding="2px 8px 2px 5px"
                color={"#344054"}
                fontSize="12px"
                fontWeight={700}
                borderRadius="50px"
                display={"flex"}
                alignItems="center"
                gap={"4px"}
              >
                <AnomalyTickIco size={"13px"} />
                Active
              </CommonGrid2>
            )}
          </CommonGrid2>
        </CommonGrid2>
      </TableCell>
      <TableCell>{row.type || "-"}</TableCell>
      <TableCell>{row.status || "-"}</TableCell>
      <TableCell>{row.created_by || "-"}</TableCell>
      <TableCell>
        {moment(row.created_at).format("DD MMM YYYY") || "-"}
      </TableCell>
      <TableCell>
        <MoreVertOutlinedIcon
          style={{ cursor: "pointer" }}
          onClick={(e) => handleIconClick(e, row)}
        />

        <CustomizeMenu
          id="basic-menu"
          anchorEl={anchorEl}
          open={attachementOpen}
          onClose={() => setAnchorEl(null)}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {attachmentMenuData.map((item, index) => (
            <MenuItem
              key={index}
              onClick={item.disabled ? () => {} : item.onClick}
              aria-controls={item.ariaControls}
              aria-haspopup={item.ariaHasPopup}
              aria-expanded={item.ariaExpanded}
              style={{ opacity: item.disabled ? 0.5 : 1 }}
              disabled={item?.disabled}
            >
              <StyledFlexRowView>
                {item.image}
                <Typography>{item.title}</Typography>
              </StyledFlexRowView>
            </MenuItem>
          ))}
        </CustomizeMenu>
      </TableCell>
    </>
  );

  const handelAttachmentDialogClose = () => {
    setDeleteButton({
      loading: false,
      open: false,
      content: "",
      id: "",
    });
  };

  const handleDownloadAttachment = async () => {
    try {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        download: true,
      }));

      const response = await CandidateAttachementDownload(
        attachementRowData.id
      );
      let filename = attachementRowData.file_name || "download";
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);

      setAttachementMenuLoader((prev) => ({
        ...prev,
        download: false,
      }));
      setAnchorEl(null);
    } catch (error) {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        download: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleDeleteAttachmentClick = () => {
    setAnchorEl(null);
    setDeleteButton((prev) => ({
      ...prev,
      open: true,
      id: attachementRowData.id,
      content: attachementRowData.name,
    }));
  };

  const handleDeleteAttachment = async () => {
    try {
      setDeleteButton((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await CandidateAttachementDelete(deleteButton?.id);
      await fetchAttachmentTableList(resumeData?.id);
      handelAttachmentDialogClose();
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
    } catch (error) {
      setDeleteButton((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleFileView = async () => {
    try {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        view: true,
      }));

      const response = await CandidateAttachementDownload(
        attachementRowData.id
      );

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        attachementRowData.file_path
      )}`;

      const isDocValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["doc", "docx"].includes(ext);
      };

      const isPdfValidFile = (fileName) => {
        const ext = fileName?.trim().split(".").pop()?.toLowerCase();
        return ext && ["pdf"].includes(ext);
      };

      if (isDocValidFile(attachementRowData.file_name)) {
        window.open(officeViewerUrl, "_blank");
      } else if (isPdfValidFile(attachementRowData.file_name)) {
        window.open(blobUrl, "_blank");
      }
      setAnchorEl(null);
      setAttachementMenuLoader((prev) => ({
        ...prev,
        view: false,
      }));
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
    } catch (error) {
      setAttachementMenuLoader((prev) => ({
        ...prev,
        view: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const attachmentMenuData = [
    {
      title: "View",
      disabled: attachementMenuLoader.view || attachementMenuLoader.download,
      image: attachementMenuLoader.view ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <EyeIco />
      ),
      onClick: () => {
        handleFileView();
      },
    },
    {
      title: "Delete",
      image: <DeleteIco />,
      disabled: attachementMenuLoader.download || attachementMenuLoader.view,
      onClick: handleDeleteAttachmentClick,
    },
    {
      title: "Download",
      disabled: attachementMenuLoader.download || attachementMenuLoader.view,
      image: attachementMenuLoader.download ? (
        <CircularProgress
          size={20}
          thickness={5}
          style={{ color: "#667085" }}
        />
      ) : (
        <Download sx={{ fontSize: "20px" }} />
      ),
      onClick: handleDownloadAttachment,
    },
  ];

  const fetchAttachmentTableList = async (resumeId) => {
    try {
      setAttachmentList((prev) => ({
        ...prev,
        loading: true,
      }));
      const data = await CandidateAttachementTableGetCall(resumeId);
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
        data: data?.data,
      }));
    } catch (error) {
      setAttachmentList((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleEditCandidate = () => {
    setEditDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleEditCandidateClose = () => {
    setEditDialog({
      open: false,
      disabled: false,
      cancelLoading: false,
      saveLoading: false,
    });
  };

  const handleEditCandidateCloseBtn = () => {
    setEditDialog((prev) => ({
      ...prev,
      disabled: true,
      cancelLoading: true,
    }));
    setTimeout(() => {
      handleEditCandidateClose();
    }, 1000);
  };

  const handleEditCandidateSubmit = async (values, initialValues) => {
    try {
      const payload = {
        candidate_first_name: {
          old_value: initialValues.candidate_first_name,
          new_value: values.candidate_first_name,
        },
        candidate_middle_name: {
          old_value: initialValues.candidate_middle_name,
          new_value: values.candidate_middle_name,
        },
        candidate_last_name: {
          old_value: initialValues.candidate_last_name,
          new_value: values.candidate_last_name,
        },

        email: {
          old_value: initialValues.email,
          new_value: values.email,
        },
        location: {
          old_value: initialValues.location,
          new_value: values.location,
        },
        title: {
          old_value: initialValues.title,
          new_value: values.title,
        },
        pay_rate: {
          new_value: {
            min: values.min.toString(),
            max: values.max.toString(),
            currency: values.rate,
          },
          old_value: {
            min: initialValues.min.toString(),
            max: initialValues.max.toString(),
            currency: initialValues.rate,
          },
        },
        source_name: {
          old_value: initialValues.source_name,
          new_value: values.source_name,
        },
        source_type: {
          old_value: initialValues.source_type,
          new_value: values.source_type,
        },
        country: values.country,
      };
      setEditDialog((prev) => ({
        ...prev,
        disabled: true,
        saveLoading: true,
      }));
      let data = await CandidateEditProfile(viewId, payload);
      await handleCandidateViewCall();
      handleEditCandidateClose();
      setSnackbarState({
        open: true,
        message: data?.message,
        severity: "success",
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setEditDialog((prev) => ({
        ...prev,
        disabled: false,
        cancelLoading: false,
        saveLoading: false,
      }));
    }
  };

  const handleChangeStatus = async (e) => {
    setStatusDialog((prev) => ({
      ...prev,
      open: true,
      value: e.target.value,
    }));
  };

  const handleStatusChange = async (condition) => {
    if (condition === "no") {
      setStatusDialog((prev) => ({
        ...prev,
        noLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        handleStatusClose();
      }, 1000);
    } else if (condition === "yes") {
      setStatusDialog((prev) => ({
        ...prev,
        yesLoading: true,
        disabled: true,
      }));
      try {
        let payload = {
          status: statusDialog.value,
          id: viewId,
        };
        const data = await CandidateStatusChange(payload);
        setSnackbarState({
          open: true,
          severity: "success",
          message: data.message,
        });
        handleStatusClose();
        await handleCandidateViewCall();
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error.message,
        });
        setStatusDialog((prev) => ({
          ...prev,
          yesLoading: false,
          disabled: false,
        }));
      }
    }
  };

  const SatusFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"No"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={statusDialog.disabled}
        loading={statusDialog.noLoading}
        onClick={() => handleStatusChange("no")}
      />
      <CommonButton
        value={"Yes"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={statusDialog.disabled}
        loading={statusDialog.yesLoading}
        onClick={() => handleStatusChange("yes")}
      />
    </CommonGrid2>
  );

  const handleStatusClose = () => {
    setStatusDialog({
      open: false,
      disabled: false,
      noLoading: false,
      yesLoading: false,
      value: "",
    });
  };

  const handleInteractionAction = (data) => {
    setInterAction({ data: data, open: true });
  };

  const handleTableBodyData = (row) => {
    return (
      <>
        <StyledTableBodyTableCell>{row.order_no}</StyledTableBodyTableCell>
        <StyledTableBodyTableCell>{row.created_by}</StyledTableBodyTableCell>
        <StyledTableBodyTableCell>{row.type}</StyledTableBodyTableCell>
        <StyledTableBodyTableCell>{row.action}</StyledTableBodyTableCell>
        <TableCell>
          <CommonGrid2
            display={"flex"}
            border="1px solid #D0D5DD"
            color="#344054"
            width="max-content"
            alignItems="center"
            borderRadius="5px"
            padding="2px 5px"
            gap="5px"
            boxShadow="0px 0px 1px 0px #101828"
            fontSize="13px"
          >
            <DotColor color={"green"} />
            {row.status}
          </CommonGrid2>
        </TableCell>
        <StyledTableBodyTableCell>{row.created_at}</StyledTableBodyTableCell>

        <TableCell>
          {row.updated_fields.length !== 0 && (
            <IconButton
              onClick={() => {
                handleInteractionAction(row);
              }}
            >
              <EyeIco />
            </IconButton>
          )}
        </TableCell>
      </>
    );
  };

  const handleToggleDrawer = () => {
    if (!open) {
      handleChatBotCandidateCall();
    }

    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Candidate",
      expandDrawer: false,
    }));
    setOpen((prev) => {
      const newState = !prev;
      dispatch(MinimizeIcon(prev, newState));
      return newState;
    });
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  useEffect(() => {
    if (chatBotData.selectedValue === "Support") {
      handleSupportCall();
    } else {
      setChatBotData((prev) => ({
        ...prev,
        selectedValue: "Candidate",
      }));
      handleChatBotCandidateCall();
    }
  }, []);

  const handleRequestInfo = async () => {
    setIsRequestLoading(true);
    const url = process.env.REACT_APP_URL;

    try {
      const payload = [
        {
          url: `${url}/candidate-coversheet?id=${viewId}&name=${
            resumeData?.personal_details?.candidate_name
          }&org_logo_url=${encodeURIComponent(
            localStorageData?.org_logo_url
          )}&organization=${localStorageData?.org_label}`,
          resume_id: viewId,
        },
      ];
      const response = await SendInterest(payload);

      setSnackbarState({
        open: true,
        message: response.message || "Request successful!",
        severity: "success",
      });
      setIsRequestLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message || "Request failed!",
        severity: "error",
      });
      setIsRequestLoading(false);
    }
  };

  const handleExpandDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      expandDrawer: !prev.expandDrawer,
    }));
  };

  const WholeProgressView = () => {
    return (
      <CommonGrid2 margin={"1.5rem 0px 1rem"}>
        {JobRescore &&
          JobRescore[viewId]?.data &&
          JobRescore[viewId]?.data?.map((file, index) => (
            <FileContainer
              key={index}
              elevation={1}
              gap={"1rem"}
              padding={"6px 10px 3px"}
              margin="16px 0px 0px"
              borderRadius="7px"
            >
              <Box display={"flex"} alignItems={"flex-start"} width={"20px"}>
                <GetFileIcon file={file} />
              </Box>

              <Box width={"100%"}>
                <CommonGrid2 display={"flex"} alignItems={"center"} gap={"5px"}>
                  <Typography
                    color="#344054"
                    fontSize={"14px"}
                    fontWeight={700}
                    textAlign={"start"}
                  >
                    {file.title}
                  </Typography>
                </CommonGrid2>

                <Typography color="#475467" fontSize={"14px"} fontWeight={500}>
                  {file.size}
                </Typography>
                {file.progress >= 0 && (
                  <CommonTippy
                    content={file.message}
                    visible={file.visible}
                    interactive={true}
                    trigger="click"
                    hideOnClick={false}
                    zIndex={2}
                    color="red"
                  >
                    <StyledLinearContainer>
                      <CommonLinearProgress
                        variant={
                          file.progress && !file.visible
                            ? "buffer"
                            : "determinate"
                        }
                        value={file.progress}
                        valueBuffer={file.buffer}
                        height={"6px"}
                        left="0px"
                        borderRadius={"2px"}
                        backgroundColor={"#E0E0E0"}
                        barbackgroundColor={file.visible ? "red" : "#7F56D9"}
                        dashedmarginTop={"1px"}
                        dashedbackgroundImage={
                          file.visible
                            ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                            : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                        }
                      />

                      <Typography
                        color="#344054"
                        fontSize={"14px"}
                        fontWeight={500}
                      >
                        {file.progress}%
                      </Typography>
                    </StyledLinearContainer>
                  </CommonTippy>
                )}
              </Box>
            </FileContainer>
          ))}
      </CommonGrid2>
    );
  };

  const rescoreContent = () => {
    return (
      <CommonGrid2>
        <Typography
          variant="h3"
          textAlign={"center"}
          color="#101828"
          fontSize={"18px"}
        >
          Rescore Candidates
        </Typography>
        {WholeProgressView()}
      </CommonGrid2>
    );
  };

  useEffect(() => {
    if (JobRescore && JobRescore?.[viewId]?.status === "success") {
      handleRescoreClose();
    }
  }, [JobRescore]);

  const handleRescoreClose = () => {
    setReScore({
      noLoading: false,
      disabled: false,
      yesLoading: false,
      open: false,
    });
  };

  const ConfirmationButton = () => {
    return (
      <CommonGrid2 display={"flex"} gap={"1rem"} marginTop={"2rem"}>
        <CommonButton
          value={"Cancel"}
          variant="outlined"
          color="#344054"
          width={"100%"}
          padding={"10px"}
          fontWeight={"700"}
          fontSize={"15px"}
          border={"#D0D5DD"}
          onClick={() => handleClickScoreConfirmation("no")}
          disabled={reScore.disabled}
          loading={reScore.noLoading}
        />

        <CommonButton
          value={"Yes"}
          width={"100%"}
          padding={"10px"}
          fontWeight={"700"}
          fontSize={"15px"}
          disabled={reScore.disabled}
          loading={reScore.yesLoading}
          onClick={() => handleClickScoreConfirmation("yes")}
        />
      </CommonGrid2>
    );
  };

  const handleClickScoreConfirmation = async (condition) => {
    if (condition === "no") {
      setReScore((prev) => ({
        ...prev,
        disabled: true,
        noLoading: true,
      }));
      setTimeout(() => {
        dispatch(JobJobRescore({ id: viewId, data: [], status: "fail" }));
        handleRescoreClose();
      }, 1000);
    } else {
      setReScore((prev) => ({
        ...prev,
        disabled: true,
        yesLoading: true,
      }));
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      const fileData = [
        {
          title: resumeData?.personal_details?.candidate_name,
          value: true,
          progress: 0,
          buffer: 0,
          type: resumeData?.resume_file_name,
          name: resumeData?.resume_file_name,
          visible: false,
          id: viewId,
        },
      ];
      const updated = {
        ...existing,
        [viewId]: {
          ...existing[viewId],
          data: fileData,
          status: "process",
        },
      };

      localStorage.setItem("JobRescore", JSON.stringify(updated));
      dispatch(
        JobJobRescore({
          id: viewId,
          data: updated[viewId].data,
          status: "process",
        })
      );
      let params = {
        score: true,
      };

      let payload = {
        job: false,
        resumes: [{ id: resumeData.id }],
      };

      try {
        const response = await CandidateRescore(viewId, payload);
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;

          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(jsonResponse, condition);
            } catch (e) {
              const storedData = JSON.parse(
                localStorage.getItem("JobRescore")
              )?.[viewId];
              const getData = storedData?.data?.map((f) =>
                f.id === jsonResponse.data.resume_id
                  ? {
                      ...f,
                      visible: true,
                      message: e.message,
                    }
                  : { ...f }
              );

              const existing =
                JSON.parse(localStorage.getItem("JobRescore")) || {};
              localStorage.setItem(
                "JobRescore",
                JSON.stringify({
                  ...existing,
                  [viewId]: {
                    data: getData,
                    status: "",
                  },
                })
              );

              dispatch(
                JobJobRescore({ id: viewId, data: getData, status: "fail" })
              );

              setSnackbarState({
                open: true,
                message: "Error parsing JSON",
                severity: "error",
              });
              setReScore({
                noLoading: false,
                disabled: false,
                yesLoading: false,
                open: true,
              });
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(jsonResponse, condition);
          } catch (e) {
            const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
              viewId
            ];
            const getData = storedData?.data?.map((f) =>
              f.id === jsonResponse.data.resume_id
                ? {
                    ...f,
                    visible: true,
                    delete: true,
                    message: e.message,
                  }
                : { ...f, delete: true, message: e.message }
            );

            const existing =
              JSON.parse(localStorage.getItem("JobRescore")) || {};
            localStorage.setItem(
              "JobRescore",
              JSON.stringify({
                ...existing,
                [viewId]: {
                  data: getData,
                  status: "",
                },
              })
            );

            dispatch(
              JobJobRescore({ id: viewId, data: getData, status: "fail" })
            );

            setSnackbarState({
              open: true,
              message: "Error parsing final JSON chunk",
              severity: "error",
            });
            setReScore({
              noLoading: false,
              disabled: false,
              yesLoading: false,
              open: true,
            });
          }
        }
      } catch (error) {
        const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
          viewId
        ];
        const getData = storedData?.data?.map((f) => ({
          ...f,
          visible: true,
          message: "Error during the request",
        }));
        const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
        localStorage.setItem(
          "JobRescore",
          JSON.stringify({
            ...existing,
            [viewId]: {
              data: getData,
              status: "",
            },
          })
        );

        dispatch(JobJobRescore({ id: viewId, data: getData, status: "fail" }));

        setSnackbarState({
          open: true,
          message: "Error during the request",
          severity: "error",
        });

        setReScore({
          noLoading: false,
          disabled: false,
          yesLoading: false,
          open: true,
        });
      }
    }
  };

  const processJsonResponse = async (jsonResponse, condition) => {
    const { success, data, message } = jsonResponse;
    if (success && data?.percent !== undefined) {
      const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
        viewId
      ];
      const getData = storedData?.data?.map((f) =>
        f.id === data.resume_id
          ? {
              ...f,
              progress: data.percent,
              buffer: data.percent,
              visible: false,
              progress_message: data.progress_message,
            }
          : f
      );
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [viewId]: {
            data: getData,
            status: "process",
          },
        })
      );
      dispatch(JobJobRescore({ id: viewId, data: getData, status: "process" }));
    } else if (data?.response) {
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [viewId]: {
            data: [],
            status: "success",
          },
        })
      );
      await handleFetchNote();
      await handleCandidateViewCall();
      dispatch(JobJobRescore({ id: viewId, data: [], status: "success" }));
      handleRescoreClose();

      setSnackbarState({
        open: true,
        severity: "success",
        message: message,
        // duration: 500,
      });
    } else if (!success) {
      const storedData = JSON.parse(localStorage.getItem("JobRescore"))?.[
        viewId
      ];
      const getData = storedData?.data?.map((f) =>
        f.id === data.resume_id || data.length == 0
          ? {
              ...f,
              visible: true,
              message: message,
            }
          : { ...f, delete: true }
      );
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [viewId]: {
            data: getData,
            status: "",
          },
        })
      );

      dispatch(JobJobRescore({ id: viewId, data: getData, status: "fail" }));

      setReScore({
        noLoading: false,
        disabled: false,
        yesLoading: false,
        open: true,
      });
    }
  };

  const handleRescoreCandidate = async () => {
    const resume_data = await dispatch(CandidateViewCall(viewId));

    setResumeData(resume_data);
    const rescoreData = JobRescore && JobRescore?.[viewId];
    if (
      rescoreData &&
      rescoreData?.status !== "success" &&
      rescoreData?.status !== "fail"
    ) {
      setReScore((prev) => ({
        ...prev,
        open: true,
        noLoading: false,
        disabled: true,
        yesLoading: true,
      }));
    } else {
      const existing = JSON.parse(localStorage.getItem("JobRescore")) || {};
      const fileData = [
        {
          title: resume_data?.personal_details?.candidate_name,
          value: true,
          progress: 0,
          buffer: 0,
          type: resume_data?.resume_file_name,
          name: resume_data?.resume_file_name,
          visible: false,
          id: viewId,
        },
      ];

      localStorage.setItem(
        "JobRescore",
        JSON.stringify({
          ...existing,
          [viewId]: {
            data: fileData,
            status: "",
          },
        })
      );
      dispatch(JobJobRescore({ id: viewId, data: fileData, status: "fail" }));

      setReScore((prev) => ({
        ...prev,
        open: true,
      }));
    }
  };

  const handleSourceCandidate = () => {
    navigate(
      `candidate-scoring?id=${resumeData?.id}&name=${resumeData?.personal_details?.candidate_name}&title=${resumeData?.personal_details?.title}`
    );
  };

  const handleGoToJob = (row, condition) => {
    const URL = process.env.REACT_APP_URL;
    window.open(
      `${URL}/jobs/jobs-view?id=${row.id}&title=${row.job_title}&value=1`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const fetchCalendlyEventTypes = async () => {
    try {
      const res = await GetCalendlyEventTypes();
      setCalendlyEvent((prev) => ({
        ...prev,
        data: res.data,
      }));
    } catch (error) {
      // setSnackbarState({
      //   open: true,
      //   message: error.message,
      //   severity: "error",
      // });
    }
  };

  const handleScheduleInterview = () => {
    setCalendlyEvent((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleScheduleSubmit = async (values) => {
    try {
      setCalendlyEvent((prev) => ({
        ...prev,
        loading: true,
      }));
      const payload = {
        event_name: values.event.name,
        event_url: values.event.scheduling_url,
        subject: "Interview Invitation – Screening Round",
        message: "Hi, please pick a slot at your convenience.",
        candidate_name: resumeData?.personal_details?.candidate_name,
        candidate_email: resumeData?.personal_details?.email,
      };
      const response = await SendCalendlyInvite(resumeData.id, payload);
      setSnackbarState({
        open: true,
        severity: "success",
        message: response.message || "Calendly invite sent successfully.",
      });
      handleCalendlyClose();
    } catch (error) {
      setCalendlyEvent((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message || "An error occurred.",
      });
    }
  };

  const handleCalendlyClose = () => {
    setCalendlyEvent((prev) => ({
      ...prev,
      open: false,
      loading: false,
    }));
  };

  return (
    <CustomDiv
      background="#F6F8FB"
      height={"100vh"}
      overflowY="auto"
      display="flex"
      ref={ref}
    >
      <CommonGrid2
        width={
          open
            ? `calc(100% - ${chatBotData.expandDrawer ? "450px" : "380px"})`
            : "100%"
        }
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.5rem 1rem 1.5rem 1.5rem"}
        position={"relative"}
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
      >
        {/* <Grid2 container spacing={2} padding={condition_based ? "0rem" : "2rem"}> */}
        <Grid2 size={12}>
          <Typography fontSize={"24px"} fontWeight={600} marginBottom={"1rem"}>
            {"Resume Intelligence Engine Module"}
          </Typography>
        </Grid2>
        <ReviewCandidateProfile
          resumeData={resumeData}
          isLoading={isLoading}
          fixLoading={fixLoading}
          handleScoreFix={handleScoreFix}
          handleDownloadResume={handleDownloadResume}
          downloadMenuLoader={downloadMenuLoader}
          handleSubmit={handleSubmit}
          handleUpdateNoteClick={handleUpdateNoteClick}
          handleClickAddNote={handleClickAddNote}
          notesTableList={notesTableList}
          notesTableListLoading={notesTableListLoading}
          handleDeleteNoteClick={handleDeleteNoteClick}
          noteHeaderData={noteHeaderData}
          condition_based={condition_based}
          handleCopyClick={handleCopyClick}
          handleCopyMouseLeave={handleCopyMouseLeave}
          copied={copied}
          attachmentList={attachmentList}
          attachementHeaderData={attachementHeaderData}
          handleAttachment={handleAttachment}
          handleAttachmentTableBodyData={handleAttachmentTableBodyData}
          interactionHeaderdata={interactionHeaderdata}
          handleEditCandidate={handleEditCandidate}
          handleEditCandidateSubmit={handleEditCandidateSubmit}
          handleEditCandidateCloseBtn={handleEditCandidateCloseBtn}
          handleEditCandidateClose={handleEditCandidateClose}
          statusOptions={statusOptions}
          handleChangeStatus={handleChangeStatus}
          handleTableBodyData={handleTableBodyData}
          request_info={"Check Interest"}
          handleRequestInfo={handleRequestInfo}
          isRequestLoading={isRequestLoading}
          profileMenuDisable={true}
          handleRescoreCandidate={handleRescoreCandidate}
          handleSourceCandidate={handleSourceCandidate}
          bounds={bounds}
          handleGoToJob={handleGoToJob}
          handleScheduleInterview={handleScheduleInterview}
          scheduleMenuLoader={calendlyEvent.data.length === 0}
        />
      </CommonGrid2>
      <CommonGrid2
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
        width={open ? (chatBotData.expandDrawer ? "450px" : "380px") : "0px"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        top={"0px"}
        position={"sticky"}
        right={"0"}
        height={"100%"}
        overflowY={"auto"}
        scrollStyle
        scrollBar="5px"
      >
        <CommonGrid2
          padding={"0rem 1rem 1rem"}
          height={"100%"}
          justifyContent={"space-between"}
          display={"flex"}
          flexDirection={"column"}
        >
          <SideBarChatBot
            handleToggleDrawer={handleToggleDrawer}
            jobId={viewId}
            // height={minimizeScreen}
            chatBotData={chatBotData}
            // handleChatBotFetchData={handleChatBotFetchData}
            handleSendMessage={handleSendMessage}
            handleChatBotChange={handleChatBotChange}
            isBottomVisible={isBottomVisible}
            setIsBottomVisible={setIsBottomVisible}
            handleUpArrow={handleUpArrow}
            userName={localStorageData?.username}
            buttonSupport={buttonSupport}
            handleButtonSupport={handleButtonSupport}
            handleExpandDrawer={handleExpandDrawer}
          />
        </CommonGrid2>
      </CommonGrid2>

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      {/* <ChatBotRelative
        bottom={iconVisible ? "-6rem" : "2rem"}
        height={!iconVisible && "70%"}
        style={{ display: "flex", alignItems: "center" }}
        zIndex={!iconVisible ? 9999 : 999}
        right={!iconVisible ? "6.5rem" : "1.5rem"}
      >
        <ChatBot
          resumeIntelligence={true}
          jobId={viewId}
          iconVisible={iconVisible}
          handleClick={handleChatBotClick}
          chatBotData={chatBotData}
          handleSendMessage={handleSendMessage}
          handleChatBotChange={handleChatBotChange}
          isBottomVisible={isBottomVisible}
          setIsBottomVisible={setIsBottomVisible}
          buttonSupport={buttonSupport}
          handleButtonSupport={handleButtonSupport}
          height={"calc(100% - 110px)"}
        />
      </ChatBotRelative> */}
      <ResumeCreateNote
        openNoteDialog={openNote.open}
        handleCloseNoteDialog={handleCloseNoteDialog}
        openNote={openNote}
        handleSubmit={handleSubmit}
      />
      <NewDeleteNote
        deleteNoteDialogOpen={openNote.deleteNote}
        handleDeleteNoteDialogClose={handleCloseNoteDialog}
        noteList={openNote}
        handleDeleteNoteById={handleDeleteNoteById}
        noteLoading={openNote.loading}
      />

      <AttachmentDialog
        open={attachmentDialog.open}
        handleClose={handleAttachmentClose}
        handleSubmit={handleAttachmentSubmit}
        attachmentDialog={attachmentDialog}
      />

      <SkillDeleteDialog
        deleteDialog={deleteButton.open}
        handleDeleteDialogClose={handelAttachmentDialogClose}
        handleDeleteSkill={handleDeleteAttachment}
        buttonLoading={deleteButton.loading}
        title="Delete Attachment"
        content={deleteButton.content}
      />
      <InteractionDialog
        open={interAction.open}
        handleClose={() =>
          setInterAction((prev) => ({
            ...prev,
            open: false,
          }))
        }
        interActionData={interAction.data}
      />
      <EditCandidateProfile
        open={editDialog.open}
        editDialog={editDialog}
        matchedData={resumeData}
        handleClose={handleEditCandidateClose}
        handleEditCandidateCloseBtn={handleEditCandidateCloseBtn}
        handleSubmit={handleEditCandidateSubmit}
        candidateDetailsEdit={true}
      />

      <ScheduleInterview
        calendlyEvent={calendlyEvent}
        onClose={handleCalendlyClose}
        handleScheduleSubmit={handleScheduleSubmit}
        storageData={localStorageData}
      />

      <DialogCandidateHub
        open={statusDialog.open}
        handleButttonClose={handleStatusClose}
        footer={<SatusFooter />}
        title={"Do you want to confirm this"}
        titlepadding={"1rem 0px 0px"}
      />
      {!open && (
        <ChatBotLabelText
          title={"My name is Hailey. Ask me about this Candidate"}
          chatBotData={chatBotData}
          handleToggleDrawer={handleToggleDrawer}
        />
      )}

      <DialogCandidateHub
        open={reScore.open}
        closeIcon={true}
        handleButttonClose={handleRescoreClose}
        footer={<ConfirmationButton />}
        icon={<RescoreIco />}
        titlepadding={"0px 0px 16px"}
        customStyle={{ top: "-6px" }}
        content={rescoreContent()}
      />
    </CustomDiv>
  );
};
export default CandidateView;
